module.exports = __webpack_public_path__ + "img/phone.8796dec7.png";